import { GamgeeChatMessageRead } from "~/types/message";
import MarkdownContainer from "~/components/markdown-container/markdown-container";

export default function GamgeeMessage({ message }: { message: GamgeeChatMessageRead }) {
  return (
    <div>
      <MarkdownContainer message={message}>{message.message.content}</MarkdownContainer>
    </div>
  );
}
